const STORAGE_KEY = 'casticart:last-login-role:v1';
const VALID_ROLES = new Set(['admin', 'artist']);

export const normalizeLastLoginRole = (role) => {
  const value = String(role || '').trim().toLowerCase();
  return VALID_ROLES.has(value) ? value : null;
};

export const getLastLoginRole = () => {
  if (typeof window === 'undefined') return null;
  try {
    const storage = window.localStorage;
    return normalizeLastLoginRole(storage.getItem(STORAGE_KEY));
  } catch (_) {
    return null;
  }
};

export const setLastLoginRole = (role) => {
  const value = normalizeLastLoginRole(role);
  if (!value || typeof window === 'undefined') return;
  try {
    const storage = window.localStorage;
    storage.setItem(STORAGE_KEY, value);
  } catch (_) {
    /* ignore storage failures */
  }
};

export const getLastLoginPath = () =>
  getLastLoginRole() === 'admin' ? '/admin-login' : '/artist-login';
